import React, { useState, useEffect, useRef, useCallback } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import ModalFrame from "../../biztran_controls/Modal_Frame";
// import CreateContact from "../../masters/accounts/CreateContact";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
// import Loader from "../../biztran_controls/Loader";


const CreateSalesOrder = (props) => {
  const classes = useStyles();
  //debugger;
  const [SalesOrderNo, setSalesOrderNo] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].SalesOrderNo === null ? '' : props.SalesOrderMainData[0].SalesOrderNo);
  const [Mode, setMode] = useState("");
  const [SalesOrderDate, setSalesOrderDate] = useState(props.SalesOrderMainData === undefined ? Moment(new Date()).format("YYYY-MM-DD") : Moment(props.SalesOrderMainData[0].SalesOrderDate).format("YYYY-MM-DD"));
  const [CompanyID, setCompanyID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].CompanyID === null ? '' : props.SalesOrderMainData[0].CompanyID);
  const [SalesOrderType, setSalesOrderType] = useState('');
  const [LeadSourceID, setLeadSourceID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].LeadSourceID === null ? '' : props.SalesOrderMainData[0].LeadSourceID);
  const [PFCharges, setPFCharges] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].PFCharges === null ? 0 : props.SalesOrderMainData[0].PFCharges);
  const [AccountName, setAccountName] = useState({ id: props.AccountID, AccountName: props.AccountName });
  const [isOpen, setOpen] = useState(false);
  const [PaymentTermsOptions, setPaymentTermsOptions] = useState(props.cmbPaymentTermsOptions.length > 0 ? props.cmbPaymentTermsOptions : []);
  const [CFCharges, setCFCharges] = useState(props.SalesOrderMainData === undefined ? 0 : props.SalesOrderMainData[0].CFCharges);
  const [PFChargesPer, setPFChargesPer] = useState(props.SalesOrderMainData === undefined ? 0 : props.SalesOrderMainData[0].PFChargesPer);
  const [PoDate, setPoDate] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].PoDate === null ? '' : Moment(props.SalesOrderMainData[0].PoDate).format("YYYY-MM-DD"));
  const [BankMasterID, setBankMasterID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BankMasterID === null ? "" : props.SalesOrderMainData[0].BankMasterID);
  const [PONumber, setPONumber] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].PONumber === null ? '' : props.SalesOrderMainData[0].PONumber);
  const [BankCmb, setBankCmb] = useState([]);
  const [FreightCharges, setFreightCharges] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].FreightCharges === null ? '' : props.SalesOrderMainData[0].FreightCharges);
  const [ContactID, setContactID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ContactID === null ? '' : props.SalesOrderMainData[0].ContactID);
  const [QuotationID, setQuotationID] = useState("");
  const [AccountID, setAccountID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].AccountID === null ? '' : props.SalesOrderMainData[0].AccountID);
  const [OtherCharges1, setOtherCharges1] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].OtherCharges1 === null ? '' : props.SalesOrderMainData[0].OtherCharges1);
  const [OtherCharges1Amt, setOtherCharges1Amt] = useState(props.SalesOrderMainData === undefined ? 0 : props.SalesOrderMainData[0].OtherCharges1Amt);
  const [OtherCharges2, setOtherCharges2] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].OtherCharges2 === null ? '' : props.SalesOrderMainData[0].OtherCharges2);
  const [OtherCharges2Amt, setOtherCharges2Amt] = useState(props.SalesOrderMainData === undefined ? 0 : props.SalesOrderMainData[0].OtherCharges2Amt);
  const [Description, setDescription] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].Description === null ? '' : props.SalesOrderMainData[0].Description);
  const [BillAddress1, setBillAddress1] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BillAddress1 === null ? '' : props.SalesOrderMainData[0].BillAddress1);
  const [BillAddress2, setBillAddress2] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BillAddress2 === null ? '' : props.SalesOrderMainData[0].BillAddress2);
  const [BillCity, setBillCity] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BillCity === null ? '' : props.SalesOrderMainData[0].BillCity);
  const [BillCountryID, setBillCountryID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BillCountryID === null ? '' : props.SalesOrderMainData[0].BillCountryID);
  const [BillStateID, setBillStateID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BillStateID === null ? '' : props.SalesOrderMainData[0].BillStateID);
  const [BillPINCode, setBillPINCode] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BillPINCode === null ? '' : props.SalesOrderMainData[0].BillPINCode);
  const [ShipAddress1, setShipAddress1] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ShipAddress1 === null ? '' : props.SalesOrderMainData[0].ShipAddress1);
  const [ShipAddress2, setShipAddress2] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ShipAddress2 === null ? '' : props.SalesOrderMainData[0].ShipAddress2);
  const [ShipCity, setShipCity] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ShipCity === null ? '' : props.SalesOrderMainData[0].ShipCity);
  const [ShipCountryID, setShipCountryID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ShipCountryID === null ? '' : props.SalesOrderMainData[0].ShipCountryID);
  const [ShipStateID, setShipStateID] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ShipStateID === null ? '' : props.SalesOrderMainData[0].ShipStateID);
  const [ShipPINCode, setShipPINCode] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ShipPINCode === null ? '' : props.SalesOrderMainData[0].ShipPINCode);
  const [Accountcmb, setAccountcmb] = useState([]);
  const [Companycmb, setCompanycmb] = useState([]);
  const [Contactcmb, setContactcmb] = useState([]);
  const [LeadSourcecmb, setLeadSourcecmb] = useState([]);
  const [BillCountrycmb, setBillCountrycmb] = useState([]);
  const [BillStatecmb, setBillStatecmb] = useState([]);
  const [ShipCountrycmb, setShipCountrycmb] = useState([]);
  const [ShipStatecmb, setShipStatecmb] = useState([]);
  const [IncoTerms, setIncoTerms] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].IncoTerms === null ? '' : props.SalesOrderMainData[0].IncoTerms);
  const [Delivery, setDelivery] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].Delivery === null ? '' : props.SalesOrderMainData[0].Delivery);
  const [HeaderSplNote, setHeaderSplNote] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].HeaderSplNote === null ? '' : props.SalesOrderMainData[0].HeaderSplNote);
  const [SplNote, setSplNote] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].SplNote === null ? '' : props.SalesOrderMainData[0].SplNote);
  const [TotalGrossWeight, setTotalGrossWeight] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].TotalGrossWeight === null ? 0 : props.SalesOrderMainData[0].TotalGrossWeight);
  const [DiscountAmount, setDiscountAmount] = useState(props.SalesOrderMainData === undefined ? 0 : props.SalesOrderMainData[0].DiscountAmount);
  const [DiscountPer, setDiscountPer] = useState(props.SalesOrderMainData === undefined ? 0 : props.SalesOrderMainData[0].DiscountPer);
  const [TotalNetWeight, setTotalNetWeight] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].TotalNetWeight === null ? 0 : props.SalesOrderMainData[0].TotalGrossWeight);
  // const [MakeID, setMakeID] = useState('');
  // const [Origin, setOrigin] = useState('');
  const [PaymentTermsID, setPaymentTermsID] = useState('');
  const [PaymentTerms, setPaymentTerms] = useState(props.SalesOrderMainData === undefined ? { id: props.PaymentTermsID, List: props.PaymentTerms } : { id: props.SalesOrderMainData[0].PaymentTermsID, List: props.SalesOrderMainData[0].PaymentTerms });
  const [Payment, setPayment] = useState(props.SalesOrderMainData === undefined ? { id: props.PaymentTermsID, List: props.PaymentTerms } : { id: props.SalesOrderMainData[0].PaymentTermsID, List: props.SalesOrderMainData[0].PaymentTerms });
  const [responsePaymentTerms, fetchPaymentTermsData] = UseFetchData();
  // const [PaymentTermsOptions, setPaymentTermsOptions] = useState([]);
  const [ModeOfTransport, setModeOfTransport] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].ModeOfTransport === null ? "" : props.SalesOrderMainData[0].ModeOfTransport);
  const [DisablePfCharges, setDisablePfCharges] = useState(false);
  const [DisablePfChargesPer, setDisablePfChargesPer] = useState(false);
  const [DisableDiscountAmount, setDisableDiscountAmount] = useState(false);
  const [DisableDiscountPer, setDisableDiscountPer] = useState(false);
  // const [scheduler, setscheduler] = useState("");
  const [Cresponse, CfetchData] = UseFetchData();
  const [Warranty, setWarranty] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].Warranty === null ? '' : props.SalesOrderMainData[0].Warranty);
  const [Weight, setWeight] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].Weight === null ? '' : props.SalesOrderMainData[0].Weight);
  const [BoxSize, setBoxSize] = useState(props.SalesOrderMainData === undefined || props.SalesOrderMainData[0].BoxSize === null ? '' : props.SalesOrderMainData[0].BoxSize);
  const [Brandcmb, setBrandcmb] = useState([]);
  const [Paymentcmb, setPaymentcmb] = useState([]);
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [isChecked, setIsChecked] = useState(false);
  // const [isDoubleChecked, setisDoubleChecked] = useState(false);
  const [responseAccDtls, fetchAccDtlsData] = UseFetchData();
  const [responsContactDtls, fetchContactDtlsData] = UseFetchData();
  const [responseComDtls, fetchComDtlsData] = UseFetchData();
  const [responsBankDtls, fetchBankDtlsData] = UseFetchData();
  const [responsStateDtls, fetchStateDtlsData] = UseFetchData();
  const [responsPayment, fetchPaymentData] = UseFetchData();
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);
  const [label, setlabel] = useState(false);
  const [loading, setLoading] = useState(true);
  const [StateCmb, seStateCmb] = useState([]);
  const [DisableSaveBtn, setDisableSaveBtn] = useState(false);
  const [portofLoading, setportofLoading] = useState(props.SalesOrderMainData === undefined ? '' : props.SalesOrderMainData[0].portOfLoading);
  const [Finaldestination, setFinaldestination] = useState(props.SalesOrderMainData === undefined ? '' : props.SalesOrderMainData[0].FinalDestination);




  const GetAccountData = (AccountID) => {
    var bodyFormData = new FormData();
    bodyFormData.append("AccountID", AccountID);
    setLoading(true);
    fetchAccDtlsData("Account/GetByID", bodyFormData);
  };

  const GetContactData = (AccountID) => {
    // debugger
    var bodyFormData = new FormData();
    if (AccountID != undefined && AccountID != "") {
      var acid = AccountID;
    }
    bodyFormData.append("AccountID", acid);
    // bodyFormData.append("AccountID", AccountID);
    setLoading(true);
    fetchContactDtlsData("SalesOrder/GetCotactDtlsByAccID", bodyFormData);
  };


  const GetBankData = (CompanyID) => {
    // debugger;
    var bodyFormData = new FormData();
    if (CompanyID != undefined && CompanyID != "") {
      var acid = CompanyID;
    }
    bodyFormData.append("CompanyID", acid);
    // bodyFormData.append("CompanyID", CompanyID);
    setLoading(true);
    fetchBankDtlsData("SalesOrder/GetBankDtls", bodyFormData);
  };


  // const GetStateData = (CountryID) => {
  //    debugger;
  //   var bodyFormData = new FormData();
  //   if (CountryID != undefined && CountryID != "") {
  //     var acid = CountryID;
  //   }
  //   bodyFormData.append("CountryID", acid);
  //   setLoading(true);
  //   fetchStateDtlsData("SalesOrder/GetStateDtls", bodyFormData);
  // };


  const AddContact = () => {
    setOpen(true);
    setContactID('');
    console.log(AccountName);
    // setMode('Insert');
  }

  const schedulerOptions = [
    { key: "3 Days", value: "3 Days" },
    { key: "1 Weak", value: "1 Weak" },
    { key: "3 Weak", value: "3 Weak" },
    { key: "1 Year", value: "1 Year" },
  ];

  const ModeOfTransportOptions = [
    { key: "By Air", value: "By Air" },
    { key: "By Road", value: "By Road" },
    { key: "By Sea", value: "By Sea" },
    { key: "Courier", value: "Courier" },
    { key: "Customer Hand", value: "Customer Hand" },
  ];

  const WarrantyOptions = [
    { key: "3 Month", value: "3 Month" },
    { key: "6 Month", value: "6 Month" },
    { key: "1 Year", value: "1 Year" },
  ];

  const IncoTermsOptions = [
    { key: "C&F", value: "C&F" },
    { key: "CFR", value: "CFR" },
    { key: "DAP", value: "DAP" },
    { key: "DDU", value: "DDU" },
    { key: "DDP", value: "DDP" },
    { key: "FCA", value: "FCA" },
    { key: "FOB", value: "FOB" },
    { key: "FOR", value: "FOR" },
    { key: "EX-WORKS", value: "EX-WORKS" },
    { key: "EX-WORKS, MUMBAI, INDIA", value: "EX-WORKS, MUMBAI, INDIA" },
    { key: "FOB, MUMBAI, INDIA", value: "FOB, MUMBAI, INDIA" },
  ];

  const IncoTermsData = () => {
    let IncoTerms = IncoTermsOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return IncoTerms;
  };

  const ModeOfTransportData = React.useCallback(() => {
    let ModeOfTransport = ModeOfTransportOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return ModeOfTransport;
  }, []);


  const validationSchema = Yup.object({
    SalesOrderDate: Yup.string().required("Required!"),
    CompanyID: Yup.string().required("Required!"),
    AccountID: Yup.string().required("Required!"),
    PoDate: Yup.string().required("Required!"),
    // BankMasterID: Yup.string().required("Required!"),
  });


  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };

  const onSubmit = values => {
    // debugger;
    setMode("Insert");
    var UpdatedByID = sessionStorage.UID;
    var GeneratedByID = sessionStorage.UID;
    var HandledByID = sessionStorage.UID;
    var bodyFormData = new FormData();
    var SalesOrderID = "";
    //debugger
    if (props.Mode === "Insert") {
      SalesOrderID = '';
    }
    else if (props.SalesOrderID == undefined) {
      SalesOrderID = props.SalesOrderMainData[0].id;
    }
    else {
      SalesOrderID = props.SalesOrderID;
    }
    bodyFormData.append("SalesOrderID", SalesOrderID);
    bodyFormData.append("SalesOrderNo", values.SalesOrderNo);
    bodyFormData.append("SalesOrderDate", values.SalesOrderDate);
    bodyFormData.append("QuotationID", '');
    bodyFormData.append("AccountID", values.AccountID);
    bodyFormData.append("ContactID", values.ContactID);
    bodyFormData.append("PFCharges", values.PFCharges);
    if (values.PFChargesPer == null || values.PFChargesPer == "null" || values.PFChargesPer == "") {
      var PFChargPer = "0";
      bodyFormData.append("PFChargesPer", PFChargPer);
    }
    else {
      bodyFormData.append("PFChargesPer", values.PFChargesPer);
    }
    if (values.CFCharges == null) {
      var OtherCA = "0";
      bodyFormData.append("CFCharges", OtherCA);
    }
    else {
      bodyFormData.append("CFCharges", values.CFCharges);
    }
    bodyFormData.append("FreightCharges", values.FreightCharges);
    bodyFormData.append("CompanyID", values.CompanyID);
    bodyFormData.append("PODate", values.PoDate);
    if (values.DiscountAmount == "null" || values.DiscountAmount == "" || values.DiscountAmount == null) {
      var DisAmount = "0";
      bodyFormData.append("DiscountAmount", DisAmount);
    } else {
      bodyFormData.append("DiscountAmount", values.DiscountAmount);
    }
    if (values.DiscountPer == "null" || values.DiscountPer == null || values.DiscountPer == "") {
      var DisPer = "0";
      bodyFormData.append("DiscountPer", DisPer);
    } else {
      bodyFormData.append("DiscountPer", values.DiscountPer);
    }
    bodyFormData.append("PONumber", values.PONumber);
    bodyFormData.append("HeaderSplNote", values.HeaderSplNote);
    bodyFormData.append("BankMasterID", values.BankMasterID);
    bodyFormData.append("LeadSourceID", values.LeadSourceID);
    bodyFormData.append("SalesOrderType", values.SalesOrderType);
    bodyFormData.append("ModeOfTransport", values.ModeOfTransport);
    bodyFormData.append("GeneratedByID", GeneratedByID);
    bodyFormData.append("HandledByID", HandledByID);
    // bodyFormData.append("Description", values.Description);
    bodyFormData.append("BillAddress1", values.BillAddress1);
    bodyFormData.append("BillAddress2", values.BillAddress2);
    bodyFormData.append("BillCity", values.BillCity);
    bodyFormData.append("BillCountryID", values.BillCountryID);
    bodyFormData.append("BillStateID", values.BillStateID);
    if (values.BillPINCode == "null") {
      var BillPin = "";
      bodyFormData.append("BillPINCode", BillPin);
    } else {
      bodyFormData.append("BillPINCode", values.BillPINCode);
    }
    bodyFormData.append("BillPINCode", values.BillPINCode);
    bodyFormData.append("ShipAddress1", values.ShipAddress1);
    bodyFormData.append("ShipAddress2", values.ShipAddress2);
    bodyFormData.append("ShipCountryID", values.ShipCountryID);
    bodyFormData.append("ShipCity", values.ShipCity);
    bodyFormData.append("ShipCountryID", values.ShipCountryID);
    bodyFormData.append("ShipStateID", values.ShipStateID);
    if (values.ShipPINCode == "null") {
      var ShipPin = "";
      bodyFormData.append("ShipPINCode", ShipPin);
    } else {
      bodyFormData.append("ShipPINCode", values.ShipPINCode);
    }
    bodyFormData.append("UpdatedByID", UpdatedByID);

    bodyFormData.append("OtherCharges1", values.OtherCharges1);
    if (values.OtherCharges1Amt == null) {
      var OtherCA = "0";
      bodyFormData.append("OtherCharges1Amt", OtherCA);
    }
    else {
      bodyFormData.append("OtherCharges1Amt", values.OtherCharges1Amt);
    }
    bodyFormData.append("OtherCharges2", values.OtherCharges2);
    if (values.OtherCharges2Amt == null) {
      var OtherCA = "0";
      bodyFormData.append("OtherCharges2Amt", OtherCA);
    }
    else {
      bodyFormData.append("OtherCharges2Amt", values.OtherCharges2Amt);
    }
    if (values.IncoTerms == null) {
      var OtherCA = "";
      bodyFormData.append("IncoTerms", IncoTerms);
    }
    else {
      bodyFormData.append("IncoTerms", values.IncoTerms);
    }
    // bodyFormData.append("BrandID", values.BrandID);
    // bodyFormData.append("Origin", values.Origin);
    // bodyFormData.append("Warranty", values.Warranty);
    if (values.portofLoading == null || values.portofLoading == "null") {
      var OtherCA = "";
      bodyFormData.append("portofLoading", OtherCA);
    }
    else {
      bodyFormData.append("portOfLoading", values.portofLoading);
    }
    if (values.SplNote == null && values.SplNote == "") {
      var OtherCA = "";
      bodyFormData.append("SplNote", OtherCA);
    }
    else {
      bodyFormData.append("SplNote", values.SplNote);
    }
    if (values.TotalGrossWeight !== null) {
      bodyFormData.append("TotalGrossWeight", values.TotalGrossWeight);
    }
    else {
      var TGW = 0;
      bodyFormData.append("TotalGrossWeight", TGW);
    }
    if (values.TotalNetWeight !== null) {
      bodyFormData.append("TotalNetWeight", values.TotalNetWeight);
    }
    else {
      var TNW = 0;
      bodyFormData.append("TotalNetWeight", TNW);
    }
    // bodyFormData.append("TotalNetWeight", values.TotalNetWeight);
    // bodyFormData.append("Weight", values.Weight);
    // bodyFormData.append("BoxSize", values.BoxSize);
    if (values.Finaldestination == null || values.Finaldestination == "null") {
      var OtherCA = "";
      bodyFormData.append("FinalDestination", OtherCA);
    }
    else {
      bodyFormData.append("FinalDestination", values.Finaldestination);
    }
    // bodyFormData.append("PaymentID", values.PaymentTermsID);
    if (SalesOrderID != "" && SalesOrderID != null) {
      var Payterm = PaymentTerms.List;
      if (Payterm == undefined) {
        bodyFormData.append("PaymentTerms", PaymentTerms);
      }
      else if (Payterm != undefined) {
        bodyFormData.append("PaymentTerms", PaymentTerms.List);
      }
    }
    else {
      bodyFormData.append("PaymentTerms", PaymentTerms);
      GetPaymentData();
    }
    if (values.Delivery == null && values.Delivery == "") {
      var OtherCA = "";
      bodyFormData.append("Delivery", OtherCA);
    }
    else {
      bodyFormData.append("Delivery", values.Delivery);
    }
    setLoading(true);
    setDisableSaveBtn(true);
    fetchData("SalesOrder/Save", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (PFCharges > 0) {
      setDisablePfChargesPer(true);
    }
    else {
      setDisablePfChargesPer(false);
    }
  }, [PFCharges]);

  useEffect(() => {
    // debugger;
    if (PFChargesPer != 0) {
      setDisablePfCharges(true);
    }
    else {
      setDisablePfCharges(false);
    }
  }, [PFChargesPer]);

  useEffect(() => {
    // debugger;
    if (DiscountPer > 0) {
      setDisableDiscountAmount(true);
    }
    else {
      setDisableDiscountAmount(false);
    }
  }, [DiscountPer]);

  useEffect(() => {
    // debugger;
    if (DiscountAmount > 0) {
      setDisableDiscountPer(true);
    }
    else {
      setDisableDiscountPer(false);
    }
  }, [DiscountAmount]);

  useEffect(() => {
    // debugger;
    if (isChecked) {
      setShipAddress1(BillAddress1);
      setShipAddress2(BillAddress2);
      setShipCountryID(BillCountryID);
      setShipStateID(BillStateID);
      setShipCity(BillCity);
      setShipPINCode(BillPINCode);
    }
    // Removed force-sync logic for Edit/Quotation modes that was overwriting custom addresses.
    // The system now preserves any existing different addresses unless the checkbox is explicitly checked.
  }, [isChecked]);


  const AccountData = React.useCallback((options) => {
    if (options !== undefined) {
      let Account = options.map((data) => (
        <option key={data.AccountName} value={data.AccountID}>
          {data.AccountName}
        </option>
      ));
      setAccountcmb(Account);
    }
  }, []);

  const ContactData = React.useCallback((options) => {
    if (options !== undefined) {
      let Contact = options.map((data) => (
        <option key={data.ContactName} value={data.ContactID}>
          {data.ContactName}
        </option>
      ));
      setContactcmb(Contact);
    }
  }, []);

  const LeadSourceData = React.useCallback((options) => {
    if (options !== undefined) {
      let LeadSource = options.map((data) => (
        <option key={data.LeadSource} value={data.LeadSourceID}>
          {data.LeadSource}
        </option>
      ));
      setLeadSourcecmb(LeadSource);
    }
  }, []);

  const BankData = React.useCallback((options) => {
    if (options !== undefined) {
      let BankName = options.map((data) => (
        <option key={data.BankName} value={data.BankMasterID}>
          {data.BankName}
        </option>
      ));
      setBankCmb(BankName);
    }
  }, []);

  const CompanyData = React.useCallback((options) => {
    if (options !== undefined) {
      let Company = options.map((data) => (
        <option key={data.CompanyName} value={data.CompanyID}>
          {data.CompanyName}
        </option>
      ));
      setCompanycmb(Company);
    }
  }, []);

  const CountryData = React.useCallback((options) => {
    if (options !== undefined) {
      let Country = options.map((data) => (
        <option key={data.Country} value={data.CountryID}>
          {data.Country}
        </option>
      ));
      setBillCountrycmb(Country);
      setShipCountrycmb(Country);
    }
  }, []);

  const BillStatecmbData = (CID) => {
    var id = "";
    if (CID !== "") {
      id = CID;
    } else if (BillCountryID !== "") {
      id = BillCountryID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["State"];
    if (options !== undefined) {
      if (id !== "") {
        let State = options
          .filter((option) => option.CountryID === id)
          .map((data) => (
            <option key={data.StateName} value={data.StateID}>
              {data.StateName}
            </option>
          ));
        setBillStatecmb(State);
      }
      else {
        let State = options.map((data) => (
          <option key={data.StateName} value={data.StateID}>
            {data.StateName}
          </option>
        ));
        setBillStatecmb(State);
      }
    }
  };

  const ShipStatecmbData = (CID) => {
    var id = "";
    if (CID !== "") {
      id = CID;
    } else if (BillCountryID !== "") {
      id = BillCountryID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["State"];
    if (options !== undefined) {
      if (id !== "") {
        let State = options
          .filter((option) => option.CountryID === id)
          .map((data) => (
            <option key={data.StateName} value={data.StateID}>
              {data.StateName}
            </option>
          ));
        setShipStatecmb(State);
      }
      else {
        let State = options.map((data) => (
          <option key={data.StateName} value={data.StateID}>
            {data.StateName}
          </option>
        ));
        setShipStatecmb(State);
      }
    }
  };

  const onCheckChange = (e) => {
    // debugger;
    setIsChecked(e.target.checked);
    console.log(isChecked);
  };

  const GetComboData = () => {
    setLoading(true);
    fetchComboData("SalesOrder/ComboData");
  };

  const onSelectChange = (e) => {
    // debugger;
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      if (targetname === "AccountID") {
        setAccountID(targetvalue);
        GetAccountData(targetvalue);
        // BillStatecmbData([]);
        GetContactData(targetvalue);
      } else if (targetname === "LeadSourceID") {
        setLeadSourceID(targetvalue);
      } else if (targetname === "CompanyID") {
        setCompanyID(targetvalue);
        setBankMasterID(targetvalue);
        // GetCompanyData(targetvalue);
        GetBankData(targetvalue);
      } else if (targetname === "ContactID") {
        setContactID(targetvalue);
      } else if (targetname === "BankMasterID") {
        setBankMasterID(targetvalue);
      } else if (targetname === "BillCountryID") {
        setBillCountryID(targetvalue);
        BillStatecmbData(targetvalue);
        // GetStateData(targetvalue);
        // StateData(targetvalue);
      } else if (targetname === "BillStateID") {
        setBillStateID(targetvalue);
      } else if (targetname === "ShipCountryID") {
        setShipCountryID(targetvalue);
        ShipStatecmbData(targetvalue);
      } else if (targetname === "ShipStateID") {
        setShipStateID(targetvalue);
        // } else if (targetname === "BrandID") {
        //   setMakeID(targetvalue);
      } else if (targetname === "PaymentTermsID") {
        setPaymentTermsID(targetvalue);
      }
    } else {
      if (targetname === "AccountID") {
        setAccountID("");
        GetAccountData("");
        // GetContactData("");
        ContactData([]);
        setBillAddress1('');
        setBillAddress2('');
        setBillCity('');
        setBillCountryID('');
        setBillStateID('');
        setBillPINCode('');
      } else if (targetname === "LeadSourceID") {
        setLeadSourceID("");
      } else if (targetname === "CompanyID") {
        setCompanyID("");
        // GetCompanyData("");
        GetBankData(targetvalue);
        BankData([]);
        setBankMasterID(targetname);
      } else if (targetname === "ContactID") {
        setContactID("");
      } else if (targetname === "BankMasterID") {
        setBankMasterID("");
      } else if (targetname === "BillCountryID") {
        setBillCountryID("");
        setBillStatecmb([]);
        // GetStateData(targetvalue);
        setBillStateID("");
      } else if (targetname === "BillCountryID") {
        setBillCountryID("");
        setBillStatecmb([]);
      } else if (targetname === "BillStateID") {
        setBillStateID("");
      } else if (targetname === "ShipCountryID") {
        setShipStateID("");
        setShipStateID([]);
      } else if (targetname === "ShipStateID") {
        setShipStateID("");
        // } else if (targetname === "BrandID") {
        //   setMakeID("");
      } else if (targetname === "PaymentTermsID") {
        setPaymentTermsID("");
      }
    }
  };



  useEffect(() => {
    // debugger;
    if (ComboDataResponse['Account'] !== undefined && ComboDataResponse['Account'].length > 0) {
      setLoading(false);
      AccountData(ComboDataResponse["Account"]);
    }
    else {
      AccountData([]);
    }
    if (ComboDataResponse['LeadSource'] !== undefined && ComboDataResponse['LeadSource'].length > 0) {
      setLoading(false);
      LeadSourceData(ComboDataResponse["LeadSource"]);
    }
    else {
      LeadSourceData([]);
    }
    if (ComboDataResponse['Country'] !== undefined && ComboDataResponse['Country'].length > 0) {
      setLoading(false);
      CountryData(ComboDataResponse["Country"]);
    }
    else {
      CountryData([]);
    }
    if (ComboDataResponse['Company'] !== undefined && ComboDataResponse['Company'].length > 0) {
      setLoading(false);
      CompanyData(ComboDataResponse["Company"]);
    }
    else {
      CompanyData([]);
    }
    // BankData(ComboDataResponse["BankMaster"])
    if (ComboDataResponse['cmbPaymentTerms'] !== undefined && ComboDataResponse['cmbPaymentTerms'].length > 0) {
      setLoading(false);
      setPaymentTermsOptions(ComboDataResponse['cmbPaymentTerms']);
    }
    else {
      setPaymentTermsOptions([]);
    }
    if (props.SalesOrderID !== "") {
      BillStatecmbData("");
      ShipStatecmbData("");
      console.log(PaymentTerms);
      setMode("Update");
    } else {
      setMode("Insert");
    }
  }, [ComboDataResponse])

  useEffect(() => {
    // debugger;
    GetComboData();
    if (AccountID != undefined && AccountID != "" && CompanyID != undefined && CompanyID != "") {
      GetBankData(CompanyID);
      GetContactData(AccountID);
    }
  }, []);


  useEffect(() => {
    if (responsContactDtls !== undefined && responsContactDtls.length > 0) {
      setLoading(false);
      ContactData(responsContactDtls);
    }
  }, [responsContactDtls]);


  useEffect(() => {
    // debugger;
    if (responsBankDtls !== undefined && responsBankDtls.length > 0) {
      setLoading(false);
      BankData(responsBankDtls);
    } else {
      setLoading(false);
      BankData([]);
    }
  }, [responsBankDtls]);



  useEffect(() => {
    // debugger;
    if ((response.Response === true) && (Mode === 'Insert')) {
      alert('Data Saved Succesfully.');
      props.setOpen(false);
      props.PopulateData();
      setLoading(false);
      setDisableSaveBtn(true);
    }
    else if (response.Response === false) {
      alert('Failed.');
      setLoading(false);
      setDisableSaveBtn(false);
    }
  }, [response])


  // useEffect(() => {
  //   if (responseComDtls !== undefined && responseComDtls.length > 0) {
  //     CompanyData(responseComDtls);
  //   }
  // }, [responseComDtls]);

  const onPaymentTermsChange = (event, newValue) => {
    // debugger;
    setPaymentTerms(newValue.List);
    setPayment(newValue);
    console.log(newValue);
  };


  const GetPaymentData = (newValue) => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("SalesOrderID", props.SalesOrderID);
    bodyFormData.append("PaymentTerms", PaymentTerms);
    setLoading(true);
    fetchPaymentData("Quotation/PaymentSubmit", bodyFormData);
  }


  useEffect(() => {
    // debugger;
    if (responseAccDtls !== undefined && responseAccDtls.length > 0) {
      setLoading(false);
      const bAddr1 = responseAccDtls[0].BillAddress1 === null ? "" : responseAccDtls[0].BillAddress1;
      const bAddr2 = responseAccDtls[0].BillAddress2 === null ? "" : responseAccDtls[0].BillAddress2;
      const bCity = responseAccDtls[0].BillCity === null ? "" : responseAccDtls[0].BillCity;
      const bCountry = responseAccDtls[0].BillCountryID === null ? "" : responseAccDtls[0].BillCountryID;
      const bState = responseAccDtls[0].BillStateID === null ? "" : responseAccDtls[0].BillStateID;
      const bPin = responseAccDtls[0].BillPINCode === null ? "" : responseAccDtls[0].BillPINCode;

      setBillAddress1(bAddr1);
      setBillAddress2(bAddr2);
      setBillCity(bCity);
      setBillCountryID(bCountry);
      setBillStateID(bState);
      setBillPINCode(bPin);

      // Fallback logic: Use billing address for shipping only if account shipping address is blank
      const sAddr1 = responseAccDtls[0].ShipAddress1 === null ? "" : responseAccDtls[0].ShipAddress1;
      if (sAddr1 === "") {
        setShipAddress1(bAddr1);
        setShipAddress2(bAddr2);
        setShipCity(bCity);
        setShipCountryID(bCountry);
        setShipStateID(bState);
        setShipPINCode(bPin);
      } else {
        setShipAddress1(sAddr1);
        setShipAddress2(responseAccDtls[0].ShipAddress2 === null ? "" : responseAccDtls[0].ShipAddress2);
        setShipCity(responseAccDtls[0].ShipCity === null ? "" : responseAccDtls[0].ShipCity);
        setShipCountryID(responseAccDtls[0].ShipCountryID === null ? "" : responseAccDtls[0].ShipCountryID);
        setShipStateID(responseAccDtls[0].ShipStateID === null ? "" : responseAccDtls[0].ShipStateID);
        setShipPINCode(responseAccDtls[0].ShipPINCode === null ? "" : responseAccDtls[0].ShipPINCode);
      }
    }
  }, [responseAccDtls])

  let IncoTermscmb = IncoTermsData();
  let ModeOfTransportcmb = ModeOfTransportData();
  // let schedulercmb = schedulerData();
  // let Warrantycmb = WarrantyData();

  return <div >
    {/* {
      loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 10,
        }}>
          <Loader />
        </div>
      )
    } */}
    <Formik initialValues={{
      SalesOrderNo: SalesOrderNo, SalesOrderDate: SalesOrderDate, AccountID: AccountID, LeadSourceID: LeadSourceID, ContactID: ContactID, SalesOrderType: SalesOrderType, CompanyID: CompanyID,
      Description: Description, BillAddress1: BillAddress1, BillAddress2: BillAddress2, BillCity: BillCity, BillCountryID: BillCountryID, BillStateID: BillStateID,
      BillPINCode: BillPINCode, ShipAddress1: ShipAddress1, ShipAddress2: ShipAddress2, ShipCity: ShipCity, ShipCountryID: ShipCountryID, ShipStateID: ShipStateID, ShipPINCode: ShipPINCode,
      Delivery: Delivery, IncoTerms: IncoTerms, DiscountAmount: DiscountAmount, DiscountPer: DiscountPer, HeaderSplNote: HeaderSplNote, PoDate: PoDate, PONumber: PONumber, BankMasterID: BankMasterID, PFCharges: PFCharges, PFChargesPer: PFChargesPer, OtherCharges2: OtherCharges2, OtherCharges2Amt: OtherCharges2Amt, OtherCharges1: OtherCharges1, OtherCharges1Amt: OtherCharges1Amt, CFCharges: CFCharges,
      FreightCharges: FreightCharges, ModeOfTransport: ModeOfTransport, Warranty: Warranty, portofLoading: portofLoading, Finaldestination: Finaldestination, SplNote: SplNote, TotalGrossWeight: TotalGrossWeight, TotalNetWeight: TotalNetWeight, Weight: Weight, BoxSize: BoxSize, PaymentTermsID: PaymentTermsID
    }}
      validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize >
      {(formik) => {
        return (
          <Form>
            <Typography style={{ marginTop: "-16px", marginBottom: "10px" }} className={classes.headertext} noWrap>
              SalesOrder Information
            </Typography>
            <Grid spacing={1} container direction="row">
              <Grid item xs={1.5} style={{ marginRight: 2 }}>
                <label
                  htmlFor={"SalesOrderNo"}
                  style={{ display: "block", width: "100%" }}
                >
                  {"SalesOrder No"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="SalesOrderNo"
                  disabled={true}
                  onChange={(e) => setSalesOrderNo(e.target.value)}
                />
              </Grid>
              <Grid itemxs={1.5} style={{ marginRight: 2 }}>
                <label
                  htmlFor={"SalesOrderDate"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"SalesOrder Date"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="date"
                  name="SalesOrderDate"
                  disabled={true}
                  onChange={(e) => setSalesOrderDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={1} style={{ marginRight: 2 }}>
                <label
                  htmlFor={"CompanyID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Company"}
                </label>
              </Grid>
              <Grid item xs={4}>
                <BiztranControlsFormik
                  control="select"
                  name="CompanyID"
                  options={Companycmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 18 }}>
                <label
                  htmlFor={"LeadSourceID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Lead Source"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="select"
                  name="LeadSourceID"
                  options={LeadSourcecmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 48 }}>
                <label
                  htmlFor={"AccountID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Account"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="select"
                  name="AccountID"
                  options={Accountcmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={1}>
                <label
                  htmlFor={"ContactID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Contact"}
                </label>
              </Grid>
              <Grid item xs={4}>
                <BiztranControlsFormik
                  control="select"
                  name="ContactID"
                  value={ContactID}
                  options={Contactcmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 45 }}>
                <label
                  htmlFor={"PoDate"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"PO Date"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="date"
                  name="PoDate"
                  onChange={(e) => setPoDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 48 }}>
                <label
                  htmlFor={"PONumber"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"PO Ref."}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="PONumber"
                  ref={ref}
                  value={PONumber}
                  onChange={(e) => {
                    setPONumber(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={1}>
                <label
                  htmlFor={"HeaderSplNote"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Misc"}
                </label>
              </Grid>
              <Grid item xs={4}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="HeaderSplNote"
                  ref={ref}
                  value={HeaderSplNote}
                  onChange={(e) => {
                    setHeaderSplNote(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 25 }}>
                <label
                  htmlFor={"BankMasterID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Bank Name"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="select"
                  name="BankMasterID"
                  value={BankMasterID}
                  options={BankCmb}
                  onChange={onSelectChange}
                />
              </Grid>
              {/* <Grid item xs={12} container direction='row'>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Description"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Description"}
                  </label>
                </Grid>
                <Grid item xs={10}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    name="Description"
                    ref={ref}
                    value={Description}
                    onChange={(e) => {
                      setDescription(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
              </Grid> */}
              <Grid item xs={12} style={{ marginTop: 3 }}>
                <Typography className={classes.headertext} noWrap>
                  Address Information
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ display: "flex", marginLeft: "50%" }}>
                <label>Shipping Address Same as Billing Address?</label>
                <div style={{ paddingLeft: 10 }}>
                  <input
                    type="checkbox"
                    name="chkbox"
                    checked={isChecked}
                    onChange={onCheckChange}
                  ></input>
                </div>
              </Grid>
              {/* <Grid item xs={6} style={{ display: "flex" }}>
                <label>Billing Address Same as Shipping Address?</label>
                <div style={{ paddingLeft: 10 }}>
                  <input
                    type="checkbox"
                    name="chkbox"
                    checked={isDoubleChecked}
                    onChange={onDoubleCheckChange}
                  ></input>
                </div>
              </Grid> */}
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Bill Address1"
                  name="BillAddress1"
                  ref={ref}
                  value={BillAddress1}
                  onChange={(e) => {
                    setBillAddress1(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Bill Address2"
                  name="BillAddress2"
                  ref={ref}
                  value={BillAddress2}
                  onChange={(e) => {
                    setBillAddress2(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Ship Address1"
                  name="ShipAddress1"
                  ref={ref}
                  value={ShipAddress1}
                  onChange={(e) => {
                    setShipAddress1(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Ship Address2"
                  name="ShipAddress2"
                  ref={ref}
                  value={ShipAddress2}
                  onChange={(e) => {
                    setShipAddress2(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Bill Country"
                  name="BillCountryID"
                  options={BillCountrycmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Bill State"
                  name="BillStateID"
                  options={BillStatecmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Ship Country"
                  name="ShipCountryID"
                  options={ShipCountrycmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Ship State"
                  name="ShipStateID"
                  options={ShipStatecmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Bill City"
                  name="BillCity"
                  ref={ref}
                  value={BillCity}
                  onChange={(e) => {
                    setBillCity(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="number"
                  label="Bill PIN Code"
                  name="BillPINCode"
                  ref={ref}
                  value={BillPINCode}
                  onChange={(e) => {
                    setBillPINCode(e.target.value)
                    handleChange()
                  }
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Ship City"
                  name="ShipCity"
                  ref={ref}
                  value={ShipCity}
                  onChange={(e) => {
                    setShipCity(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="number"
                  label="Ship PIN Code"
                  name="ShipPINCode"
                  ref={ref}
                  value={ShipPINCode}
                  onChange={(e) => {
                    setShipPINCode(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={12} >
                <Typography className={classes.headertext} noWrap>
                  Terms & Conditions
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Delivery"
                  name="Delivery"
                  ref={ref}
                  value={Delivery}
                  onChange={(e) => {
                    setDelivery(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Inco Terms"
                  options={IncoTermscmb}
                  name="Incoterms"
                  //disabled={true}
                  value={IncoTerms}
                  onChange={(e) => setIncoTerms(e.target.value)}
                />
              </Grid>

              <Grid item xs={3}>
                <label
                  htmlFor={"PFCharges"}
                  style={{
                    display: "block",
                    marginTop: 25,
                    width: "100%",
                  }}
                >
                  {"Packing & Forwarding"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Charges"
                  name="PFCharges"
                  disabled={DisablePfCharges}
                  onChange={(e) => {
                    setPFCharges(e.target.value)
                  }
                  }
                />
              </Grid>
              <Grid item xs={1}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label=" % "
                  name="PFChargesPer"
                  disabled={DisablePfChargesPer}
                  onChange={(e) => {
                    setPFChargesPer(e.target.value)
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="ModeOfTransport"
                  name="ModeOfTransport"
                  options={ModeOfTransportcmb}
                  onChange={(e) => setModeOfTransport(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Freight Terms"
                  name="FreightCharges"
                  ref={ref}
                  value={FreightCharges}
                  onChange={(e) => {
                    setFreightCharges(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <label
                  htmlFor={"DiscountAmount"}
                  style={{
                    display: "block",
                    marginTop: 20,
                    width: "100%",
                  }}
                >
                  {"Discount"}
                </label>
              </Grid>
              <Grid item xs={2} style={{ marginTop: 15 }} >
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="DiscountAmount"
                  disabled={DisableDiscountAmount}
                  onChange={(e) => {
                    setDiscountAmount(e.target.value)
                  }
                  }
                />
              </Grid>
              <Grid item xs={1} style={{ marginTop: 15 }}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="DiscountPer"
                  disabled={DisableDiscountPer}
                  onChange={(e) => {
                    setDiscountPer(e.target.value)
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="CFCharges"
                  name="CFCharges"
                  ref={ref}
                  value={CFCharges}
                  onChange={(e) => {
                    setCFCharges(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                {/* <BiztranControlsFormik
                  control="select"
                  label="PaymentTerms"
                  name="PaymentTermsID"
                  options={Paymentcmb}
                  onChange={onSelectChange}
                /> */}
                <BiztranControls.Autocomplete
                  control="input"
                  type="text"
                  label="Payment Terms"
                  options={PaymentTermsOptions}
                  style={{ marginTop: 5, width: "217px" }}
                  onChange={onPaymentTermsChange}
                  onChangeText={(e) => {
                    setPaymentTerms(e.target.value)
                  }}
                  value={Payment}
                >
                </BiztranControls.Autocomplete>
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-1 "
                  name="OtherCharges1"
                  ref={ref}
                  value={OtherCharges1}
                  onChange={(e) => {
                    setOtherCharges1(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-1 value"
                  name="OtherCharges1Amt"
                  onChange={(e) => {
                    setOtherCharges1Amt(e.target.value)
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Total Net Weight"
                  name="TotalNetWeight"
                  ref={ref}
                  value={TotalNetWeight}
                  onChange={(e) => {
                    setTotalNetWeight(e.target.value)
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Total Gross Weight"
                  name="TotalGrossWeight"
                  ref={ref}
                  value={TotalGrossWeight}
                  onChange={(e) => {
                    setTotalGrossWeight(e.target.value)
                    // handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-2 "
                  name="OtherCharges2"
                  onChange={(e) => {
                    setOtherCharges2(e.target.value)

                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-2 value"
                  name="OtherCharges2Amt"
                  onChange={(e) => {
                    setOtherCharges2Amt(e.target.value)
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  // label="Warranty"
                  // name="Warranty"
                  label="Port of Loading"
                  name="portofLoading"
                  ref={ref}
                  value={portofLoading}
                  onChange={(e) => {
                    // setWarranty(e.target.value)
                    setportofLoading(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  // label="BoxSize"
                  // name="BoxSize"
                  label="Final Destination"
                  name="Finaldestination"
                  ref={ref}
                  value={Finaldestination}
                  onChange={(e) => {
                    // setBoxSize(e.target.value)
                    setFinaldestination(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Special Note"
                  name="SplNote"
                  ref={ref}
                  value={SplNote}
                  onChange={(e) => {
                    setSplNote(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    <BiztranControls.Button
                      text="SAVE"
                      type="submit"
                      disabled={DisableSaveBtn}
                      startIcon={<SaveIcon />}
                    />
                    <BiztranControls.Button
                      text="CLOSE"
                      startIcon={<CloseIcon />}
                      onClick={() => {
                        props.setOpen(false);
                      }}
                    />
                    {/* <ModalFrame
                      title="Contact Details"
                      maxWidth="md"
                      isOpen={isOpen}
                      headerAlign="center"
                      setOpen={setOpen}
                    >
                      <CreateContact
                        ContactID={ContactID}
                        AccountID={AccountID}
                        AccountName={AccountName}
                        setOpen={setOpen}
                        PopulateData={PopulateData}
                      />
                    </ModalFrame> */}
                  </div>
                </div>
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  </div>;
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginLeft: "-24px",
    marginRight: "-24px",
  },
}));

export default CreateSalesOrder;